export default __webpack_public_path__ + "static/media/RioGallegos.6b18bbd7.jpg";